function initGeolocate() {

	const container = document.querySelector('div.geo-content');
	const spinner = document.querySelector('div.geo-content h1 svg.loading');
	
	if(container && spinner) {
		navigator.geolocation.getCurrentPosition(
			async (position)=>{
				try {
					const response = await fetch('/api/geolocation.php', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
							accuracy: position.coords.accuracy
						})
					});
					if(!response.ok) {
						showGenericError();
					}
					else {
						const html = await response.text();
						if(html === 'error') {
							showGenericError();
							return;
						}
						else if(html === 'out-of-bounds') {
							showBoundsError();
							return;
						}
						
						container.innerHTML = html;
						
						changeDistanceUnits();
						onMapsReady(initMaps);
						
						container.querySelectorAll('.adsbygoogle').forEach(ad => {
							if(!ad.dataset.adsbygoogleStatus) {
								(window.adsbygoogle = window.adsbygoogle || []).push({});
							}
						});
						
					}
				} catch (error) {
					showGenericError();
				}
			},
			(error)=>{
				if(error.code === 1) showPermissionsError();
				else showGenericError();
			},
			{
				enableHighAccuracy: true,
				timeout: 60000,
				maximumAge: 60000
			}		
		);
		
		function showGenericError() {
			spinner.remove();
			container.querySelector('.generic-error').style.display = 'block';
		}
		
		function showPermissionsError() {
			container.querySelector('h1').innerText = 'We couldn’t access your location';
			container.querySelector('.permissions-error').style.display = 'block';
		}
		
		function showBoundsError() {
			spinner.remove();
			container.querySelector('.out-of-bounds-error').style.display = 'block';
		}
	}
}
initGeolocate();